import Reflux from 'reflux-react-16'

export default Reflux.createActions([
    'setDate',
    'getCustomers',
    'getShifts',
    'getRoutes',
    'getRoute',
    'selectRoute',
    'selectShift',
    'setRouteStartTime',
    'startScanning',
    'cancelScanning',
    'setColloReady',
    'loadRoute',
    'startRoute',
    'stopRoute',
    'setRouteReady',
    'setRouteLocked',
    'setAddressLocked',
    'planRoute',
    'updateRoute',
    'scan',
    'downloadAttachment',
    'readNotification',
    'setMessengerLocation',
    'getNotPossibleReasons',
    'getAddressPackages'
])
